import React from "react";
import { GreyCardProps } from ".";
import { FlexVertical } from "../Flex";
import { Text } from "../Text";
import { Title } from "../Title";

export const GreyCard: React.FC<GreyCardProps> = ({ title, content }) => (
  <FlexVertical bg="greyLight" p={4} data-testid="GreyCard">
    <Title as="h2" m={0}>
      {title}
    </Title>
    <Text dangerouslySetInnerHTML={{ __html: content }} />
  </FlexVertical>
);
